import { Button, Input, Modal } from "components";
import { Controller, useFormContext } from "react-hook-form";
import { PaymentInvoiceType } from "../types";
import { TbInfoCircle } from "react-icons/tb";
import { useToggle } from "utils";
import InvoiceDetail from "../../Invoice/components/Detail";
import { useContext } from "react";
import { DataContext } from "../../Invoice/contexts";

export function LinkToInvoice(): JSX.Element {
    const { control } = useFormContext<PaymentInvoiceType>()


    return (
        <section className="flex items-end">
            <section className="grow">
                <Controller
                    control={control}
                    name="link"
                    render={({ field }) => (
                        <Input
                            disabled
                            label="LINK TO INVOICE ID"
                            defaultValue={field.value}
                        />
                    )}
                />
            </section>

            <DetailSection />
        </section>
    )
}

function DetailSection(): JSX.Element {
    const { isActive, toggle } = useToggle(false)
    const { sales_order_id, invoice_id } = useContext(DataContext)

    return (
        <>
            <Button
                type="button"
                color="primary"
                onClick={toggle}
            >
                <TbInfoCircle />
            </Button>

            {isActive && (
                <Modal
                    isOpen
                    title="INVOICE DETAIL"
                    closeModal={toggle}
                >
                    <Modal.Body>
                        <InvoiceDetail
                            sales_order_id={sales_order_id.toString()}
                            invoice_id={invoice_id}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}